'use client';
import { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';
import { cn } from '@/app/utils';

interface ChatInputDisclaimerProps {
  className?: string;
  maxWidthClassName?: string;
}

export const ChatInputDisclaimer = ({ className, maxWidthClassName = 'max-w-[960px]' }: ChatInputDisclaimerProps) => {
  const t = useTranslations();
  const disclaimer = SITE === 'china' ? '回复由AI生成，仅供参考，请注意核实' : t('claw.chat.tip');

  return (
    <div
      className={cn(
        'w-full text-center text-xs',
        'light:text-system-text04 text-system-white24',
        maxWidthClassName,
        className,
      )}
    >
      {disclaimer}
    </div>
  );
};
